import React from 'react';

import {translate} from 'views/module';

import backend from 'utils/backend';

const STAGES_REQUIRING_REASON = ['CLOSED_LOST', 'INACTIVE'];

const errorMessage = (error) => {
  return translate(`loomLead.ChangeStatus.Errors.${error.code === 'CLT_007' ? 'CLT_007' : 'Default'}`);
};

const useStageChange = (props) => {
  const {clientId, selectedStage, onChanged, progressWrap} = props;

  const [pendingStage, setPendingStage] = React.useState(null);

  const save = (stage, reason = {}) => {
    return progressWrap(async () => {
      await backend.loom.loomLead.updateStatus(clientId, {status: stage, ...reason});
      onChanged(stage, reason);
    }, {
      onErrorMessage: errorMessage,
      debugString: 'LOOM_LEAD_STATUS',
    });
  };

  const selectStage = (stage) => {
    if (!stage || stage === selectedStage) return;

    if (STAGES_REQUIRING_REASON.includes(stage)) {
      setPendingStage(stage);
      return;
    }

    save(stage);
  };

  const saveReason = (reason) => {
    const stage = pendingStage;
    setPendingStage(null);
    return save(stage, reason);
  };

  const closeReason = () => setPendingStage(null);

  return {pendingStage, selectStage, saveReason, closeReason};
};

export default useStageChange;
